<template>
  <div class="details_content_repeat">
    <QS-h4-title :title="title" />
    <div class="details_content_repeat_hundred">
      <el-form label-width="200px">
        <column-box :source="source" :list="list" :labelWidth="labelWidth">
        <slot name="default"></slot>
        </column-box>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detailBaseInfo',
  props: {
    title: {
      type: String,
      default: '',
    },
    source: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => ([]),
    },
    labelWidth: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {

    }
  },
}
</script>

<style scope>
.details_content_repeat{
    margin-top: 10px;
}
</style>
